export const appointmentConstant = {
  TOTAL_BOX_COUNT: `totalBoxCount`,
  ARTICLE_WISE_BOX_COUNT: `articleWiseBoxCount`
};
